import React from 'react';

const AdminIndex: React.FC = () => {
  return <div>AdminIndex</div>;
};

export default AdminIndex;
